import React, { useEffect } from 'react';
import { logging } from '../../SharedLib/Util/LoggingUtil';
import { authUtil } from '../../SharedLib/Util/AuthUtil';
import { getSanitizedRedirectUrl } from '../../SharedLib/Util/RedirectUtil';
import LoadingModal from '../../SharedLib/Component/LoadingModal/LoadingModal';
import { removeCustomSocialAuthStateCookie } from '../CustomSocialAuth/CustomSocialAuthUtil';

/**
 * Dedicated `/logout` route: clears session cookies via **`SharedLib`** `authUtil`, then clears
 * **custom-social-auth progress** ({@link removeCustomSocialAuthStateCookie}), then redirects —
 * **`LogoutFullPage` is not used**, so **`SharedLib` stays unaware** of profile-only cookies.
 */
function Logout() {
  const redirectUrl = getSanitizedRedirectUrl({ loggedOut: true, fallback: '/' });

  useEffect(() => {
    document.title = 'Log out - W3Schools';
  });

  useEffect(() => {
    const logout = async () => {
      logging.logInfo('Logging out and redirecting to: ', redirectUrl);
      await authUtil.logOut({
        context: 'LFPC',
        reason: {
          landedOnLogOutPage: true,
        },
      });
      removeCustomSocialAuthStateCookie();
      window.location.href = redirectUrl!;
    };

    logout();
  }, []);

  return (
    <div>
      <LoadingModal
        header="Logging out..."
        message="You are now being logged out from W3Schools"
        show={true}
        full_page={true}
        close={() => undefined}
      />
    </div>
  );
}

export default Logout;
